import { AxiosResponse } from 'axios';
import Encoding from 'encoding-japanese';

const download = (blobParts: BlobPart[], type: string, filename: string) => {
  const blob = new Blob(blobParts, { type });
  const objectURL = URL.createObjectURL(blob);
  downloadFromUrl(objectURL, filename);
};

export const downloadEncodedCsv = (csv: string, type: string, filename: string, isJapanese: boolean) => {
  const utf8Array = new TextEncoder().encode(csv);
  // Japanese has a specific encoding standard and might be garbled if we don't encode as Shift-JIS
  if (isJapanese) {
    const sjisArray = Encoding.convert(utf8Array, { to: 'SJIS', from: 'UTF8' });
    const blobPart = new Uint8Array(sjisArray);
    download([blobPart], type, filename);
  } else {
    download([utf8Array], type, filename);
  }
};

export const downloadFromUrl = (href: string, filename?: string) => {
  const anchor = document.createElement('a');
  anchor.href = href;
  if (filename) {
    anchor.download = filename;
  }
  anchor.click();
  // clean up
  anchor.remove();
  // don't forget to revoke your Blob URLs, or it will be held im browsers memory!
  URL.revokeObjectURL(href);
};

export function downloadFileFromAxiosResponse(response: AxiosResponse<Blob | string>) {
  const disposition = response.request.getResponseHeader('Content-Disposition');
  let fileName = '';
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(disposition);
  if (matches != null && matches[1]) {
    fileName = matches[1].replace(/['"]/g, '');
  }
  const blob = new Blob([response.data], { type: response.headers['content-type'] });

  const tempElement = document.createElement('a');
  tempElement.href = URL.createObjectURL(blob);
  tempElement.download = fileName;
  document.body.appendChild(tempElement);
  tempElement.click();
  document.body.removeChild(tempElement);
}

export default download;
